/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";
import { FieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";

export const form_pripravenostStavby = Form({
    id: "pripravenost-stavby",
    version: "2020-07-r1",
    title: "Připravenost stavby",
    icon: "home-city",
    showInMenu: true
}, [
    SectionGroup({}, [
        Section({
            id: "hlavni_obsah",
            title: "Připravenost stavby"
        }, [
            Row({
                id: "obsah"
            }, [
                HTMLContent({}, (data) => <>
                    <h2 style={{
                        textAlign: "center",
                        padding: "15px",
                        fontWeight: "bold",
                        fontSize: "30px"
                    }}>
                        Připravenost stavby pro zaměření kuchyně
                    </h2>
                    <p style={{
                        textAlign: "center",
                        padding: "15px"
                    }}>
                        čistá betonová podlaha + informace o tloušťce následně položené podlahové krytiny
                        <br />
                        <br />
                        vyštukované stěny v prostoru kuchyně
                        <br />
                        <br />
                        čistý strop, případně sádrokartonový podhled
                        <br />
                        <br />
                        informace o jakýchkoliv překážkách v prostoru (topení, servisní dvířka, atd.)
                    </p>
                    <p style={{
                        textAlign: "center",
                        padding: "15px",
                        fontWeight: "bold",
                        fontSize: "30px"
                    }}>
                        Od zaměření prostoru běží lhůta<br />
                        6 - 8 týdnů pro instalaci nábytku
                    </p>
                    <h2 style={{
                        textAlign: "center",
                        padding: "15px",
                        fontWeight: "bold",
                        fontSize: "30px"
                    }}>
                        Připravenost stavby pro instalaci nábytku
                    </h2>
                    <p style={{
                        textAlign: "center",
                        padding: "15px"
                    }}>
                        čistá betonová podlaha + informace o tloušťce následně položené podlahové krytiny
                        <br />
                        <br />
                        hotové elektroinstalace a rozvody vody a odpadů (osazené rohové ventily a odpady)
                        <br />
                        <br />
                        připojené instalace k řádu a síti
                        <br />
                        <br />
                        připravená vzduchotechnika a případná SDK konstrukce + konstrukce pro ostrůvkový odsavač
                        <br />
                        <br />
                        hotová výmalba prostoru
                        <br />
                        <br />
                        položená podlahová krytina
                        <br />
                        <br />
                        zajištěna minimální teplota 15°C, osvětlení a sociální zařízení
                    </p>
                    <p style={{
                        textAlign: "center",
                        padding: "15px",
                        fontWeight: "bold",
                        fontSize: "30px"
                    }}>
                        Případná SDK konstrukce<br />
                        není součástí dodávky nábytku
                    </p>
                    <p style={{
                        textAlign: "center",
                        padding: "15px",
                        fontWeight: "bold",
                        fontSize: "30px"
                    }}>
                        Zapojení spotřebičů a vybavení proběhne<br />
                        do 5-ti dnů od instalace nábytku
                    </p>
                    <p style={{
                        textAlign: "center",
                        padding: "15px"
                    }}>
                        součástí zapojení je dodávka standardního materiálu<br />
                        (vodovodní hadice pro baterii do 0,5m, sifon, odtahová flexi roura pro digestoř max. 1m)
                        <br />
                        <br />
                        další nestandardní materiál bude po dohodě doúčtován v konečné faktuře
                        <br />
                        <br />
                        <br />
                        <br />
                    </p>
                </>)
            ])
        ]),
        Section({
            id: "podpisova_sekce",
            title: "Potvrzení převzetí formuláře"
        }, [
            Row({
                id: "podpisy"
            }, [
                HTMLContent({}, (data) => <>
                    <table style={{
                        width: "100%"
                    }}>
                        <tr>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "30px"
                            }}
                                colSpan={2}
                            >
                                V Českých Budějovicích, dne:
                            </td>
                        </tr>
                        <tr>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "100px"
                            }}>
                                <p>
                                    . . . . . . . . . . . . . . . . . . . .
                                </p>
                                <p>
                                    <strong>Podpis a razítko<br />prodejce</strong>
                                </p>
                            </td>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "100px"
                            }}>
                                <p>
                                    . . . . . . . . . . . . . . . . . . . .
                                </p>
                                <p>
                                    <strong>Podpis<br />zákazníka</strong>
                                </p>
                            </td>
                        </tr>
                    </table>
                </>)
            ]),
        ])
    ])
]);